import { Injectable, Inject } from "@angular/core";
import { Http, Headers, RequestOptions } from "@angular/http";
import { environment } from "../../environments/environment";
import { CommonService } from "./common.service";
import { FileUploadService } from "./file-upload.service";
import { Observable } from "rxjs/Observable";
import "rxjs/add/operator/map";

@Injectable()
export class HttpClientService {
  BASE_ENDPOINT: string = environment.BASE_ENDPOINT;
  DFS_ENDPOINT: string = environment.DFS_ENDPOINT;
  API_ENDPOINT: string = environment.API_ENDPOINT;
  HSM_API_ENDPOINT: string = environment.HSM_API_ENDPOINT;
  MFS_API_ENDPOINT: string = environment.MFS_API_ENDPOINT;
  DFS_GROUP_API_ENDPOINT: string = environment.DFS_USER_GROUP_API_ENDPOINT;
  DFS_LOYALTY_ENDPOINT: string = environment.DFS_LOYALTY_ENDPOINT;
  DFS_USER_MANAGEMENT_ENDPOINT: string =
    environment.DFS_USER_MANAGEMENT_ENDPOINT;
  DFS_LOGIN_MANAGEMENT_ENDPOINT: string =
    environment.DFS_LOGIN_MANAGEMENT_ENDPOINT;
  DFS_AUTHORIZATION_SERVER_ENDPOINT: string =
    environment.DFS_AUTHORIZATION_SERVER_ENDPOINT;
  MFS_USER_GROUP_API_ENDPOINT: string = environment.MFS_USER_GROUP_API_ENDPOINT;
  WALLET_MANAGEMENT_ENDPOINT: string = environment.WALLET_MANAGEMENT_ENDPOINT;
  MFS_WALLET_MANAGEMENT_ENDPOINT: string =
    environment.MFS_WALLET_MANAGEMENT_ENDPOINT;
  LIMIT_MANAGEMENT_ENDPOINT: string = environment.LIMIT_MANAGEMENT_ENDPOINT;
  MFS_REPORTING_ENDPOINT: string = environment.MFS_REPORTS_ENDPOINT;
  MFS_SERVICE_ENDPOINT: string =
    environment.MFS_SERVICE_MANAGEMENT_API_ENDPOINT;
  MFS_SERVICE_GROUP_MANAGEMENT_ENDPOINT: string =
    environment.MFS_SERVICE_GROUP_MANAGEMENT_ENDPOINT;
  MFS_BILLER_MANAGEMENT_ENDPOINT: string = environment.BILLER_ENDPOINT;
  ENDPOINT: string = environment.ENDPOINT;
  USER_MFS: string = environment.USER_MFS;
  COMMON_UTILS: string = environment.COMMON_UTILS;
  LOGIN_MFS: string = environment.LOGIN_MFS;
  COMMON_UTILS_HIERARCHY: string = environment.COMMON_UTILS_HIERARCHY;
  MFS_HIERARCHY_DOWNLOAD: string = environment.MFS_HIERARCHY_DOWNLOAD;
  OPERATIONS_ENDPOINT: string = environment.OPERATIONS_ENDPOINT;
  DASHBOARD_ENDPOINT: string = environment.DASHBOARD_ENDPOINT;
  MFS_TRANSACTION_MANAGEMENT_API_ENDPOINT: string =
    environment.MFS_TRANSACTION_MANAGEMENT_API_ENDPOINT;
  SMS_ENDPOINT: string = environment.SMS_ENDPOINT;
  POINTPRO_ENDPOINT: string = environment.POINTPRO_ENDPOINT;
  CAMPAIGN_ENDPOINT: string = environment.CAMPAIGN_ENDPOINT;
  PRODIGI_CREDIT_ENDPOINT: string = environment.PRODIGI_CREDIT_ENDPOINT;
  DFS_WALLET_MANAGEMENT_ENDPOINT: string =
    environment.DFS_WALLET_MANAGEMENT_ENDPOINT;
  constructor(
    private http: Http,
    private commonService: CommonService,
    private ser: FileUploadService
  ) {}

  get(
    url,
    param?: any,
    endpoint = 2,
    headers?: RequestOptions,
    type = null,
    typeExtension = null,
    extraRequestOptions?
  ): Observable<any> {
    let apiEndPoint = this.API_ENDPOINT;
    if (endpoint === 0) apiEndPoint = this.BASE_ENDPOINT;
    else if (endpoint === 1) apiEndPoint = this.HSM_API_ENDPOINT;
    else if (endpoint === 3) apiEndPoint = this.MFS_API_ENDPOINT;
    else if (endpoint === 4) apiEndPoint = this.MFS_USER_GROUP_API_ENDPOINT;
    else if (endpoint === 5) apiEndPoint = this.WALLET_MANAGEMENT_ENDPOINT;
    else if (endpoint === 6) apiEndPoint = this.ENDPOINT;
    else if (endpoint === 7) apiEndPoint = this.USER_MFS;
    else if (endpoint === 8) apiEndPoint = this.LIMIT_MANAGEMENT_ENDPOINT;
    else if (endpoint === 9) apiEndPoint = this.LOGIN_MFS;
    else if (endpoint === 13) apiEndPoint = this.MFS_SERVICE_ENDPOINT;
    else if (endpoint === 10)
      apiEndPoint = this.MFS_SERVICE_GROUP_MANAGEMENT_ENDPOINT;
    else if (endpoint === 15) apiEndPoint = this.OPERATIONS_ENDPOINT;
    else if (endpoint === 16) apiEndPoint = this.MFS_REPORTING_ENDPOINT;
    else if (endpoint === 17) apiEndPoint = this.MFS_BILLER_MANAGEMENT_ENDPOINT;
    else if (endpoint === 19) apiEndPoint = this.MFS_BILLER_MANAGEMENT_ENDPOINT;
    else if (endpoint === 18) apiEndPoint = this.DASHBOARD_ENDPOINT;
    else if (endpoint === 20)
      apiEndPoint = this.MFS_TRANSACTION_MANAGEMENT_API_ENDPOINT;
    else if (endpoint === 21) apiEndPoint = this.COMMON_UTILS;
    else if (endpoint === 22) apiEndPoint = this.MFS_HIERARCHY_DOWNLOAD;
    else if (endpoint === 23) apiEndPoint = this.SMS_ENDPOINT;
    else if (endpoint === 24) apiEndPoint = this.POINTPRO_ENDPOINT;
    else if (endpoint === 25) apiEndPoint = this.DFS_ENDPOINT;
    else if (endpoint === 26) apiEndPoint = this.DFS_GROUP_API_ENDPOINT;
    else if (endpoint === 27) apiEndPoint = this.DFS_LOYALTY_ENDPOINT;
    else if (endpoint === 28) apiEndPoint = this.PRODIGI_CREDIT_ENDPOINT;
    else if (endpoint === 29) apiEndPoint = this.CAMPAIGN_ENDPOINT;
    else if (endpoint === 30) apiEndPoint = this.DFS_USER_MANAGEMENT_ENDPOINT;
    else if (endpoint === 31) apiEndPoint = this.DFS_WALLET_MANAGEMENT_ENDPOINT;
    else if (endpoint === 32) apiEndPoint = this.MFS_WALLET_MANAGEMENT_ENDPOINT;
    else if (endpoint === 33) apiEndPoint = this.DFS_LOGIN_MANAGEMENT_ENDPOINT;

    let header = headers
      ? this.jwt(headers, extraRequestOptions)
      : this.jwt(null, extraRequestOptions);

    if (param != null && typeof param === "object") {
      param = this.commonService.stringParams(param);
    }

    if (param != null) {
      param = "?" + param;
    } else {
      param = "";
    }

    if (type == "blob") {
      var fileExtension = { type: "text/csv;charset=ISO-8859-1" };
      if (typeExtension != null) {
        fileExtension = {
          type: this.commonService.downloadFileFormats[typeExtension],
        };
      }
      return this.http
        .get(apiEndPoint + url + param, header)
        .map((res) => new Blob([res.blob()], fileExtension));
    } else {
      return this.http
        .get(apiEndPoint + url + param, header)
        .map((res) => res.json());
    }

    //    return this.http.get(apiEndPoint + url + param, header).map(res => res.json());
  }

  download(url, param?: any, endpoint = 2): Observable<any> {
    let apiEndPoint = this.API_ENDPOINT;
    if (endpoint === 8) apiEndPoint = this.LIMIT_MANAGEMENT_ENDPOINT;
    if (endpoint === 21) apiEndPoint = this.COMMON_UTILS;
    if (endpoint === 11) apiEndPoint = this.COMMON_UTILS_HIERARCHY;

    if (param != null && typeof param === "object") {
      param = this.commonService.stringParams(param);
    }

    if (param != null) {
      param = "?" + param;
    } else {
      param = "";
    }

    return this.http
      .get(apiEndPoint + url + param, this.jwt())
      .map((res) => res);
  }

  post(
    url,
    param?: any,
    endpoint = 2,
    headers?: RequestOptions,
    type = null
  ): any {
    let apiEndPoint = this.API_ENDPOINT;
    if (endpoint === 0) apiEndPoint = this.BASE_ENDPOINT;
    else if (endpoint === 1) apiEndPoint = this.HSM_API_ENDPOINT;
    else if (endpoint === 3) apiEndPoint = this.MFS_API_ENDPOINT;
    else if (endpoint === 4) apiEndPoint = this.MFS_USER_GROUP_API_ENDPOINT;
    else if (endpoint === 5) apiEndPoint = this.WALLET_MANAGEMENT_ENDPOINT;
    else if (endpoint === 6) apiEndPoint = this.ENDPOINT;
    else if (endpoint === 7) apiEndPoint = this.USER_MFS;
    else if (endpoint === 8) apiEndPoint = this.LIMIT_MANAGEMENT_ENDPOINT;
    else if (endpoint === 9) apiEndPoint = this.LOGIN_MFS;
    else if (endpoint === 13) apiEndPoint = this.MFS_SERVICE_ENDPOINT;
    else if (endpoint === 10)
      apiEndPoint = this.MFS_SERVICE_GROUP_MANAGEMENT_ENDPOINT;
    else if (endpoint === 15) apiEndPoint = this.OPERATIONS_ENDPOINT;
    else if (endpoint === 16) apiEndPoint = this.MFS_REPORTING_ENDPOINT;
    else if (endpoint === 17) apiEndPoint = this.MFS_BILLER_MANAGEMENT_ENDPOINT;
    else if (endpoint === 19) apiEndPoint = this.COMMON_UTILS;
    else if (endpoint === 18) apiEndPoint = this.DASHBOARD_ENDPOINT;
    else if (endpoint === 20)
      apiEndPoint = this.MFS_TRANSACTION_MANAGEMENT_API_ENDPOINT;
    else if (endpoint === 22) apiEndPoint = this.MFS_HIERARCHY_DOWNLOAD;
    else if (endpoint === 23) apiEndPoint = this.SMS_ENDPOINT;
    else if (endpoint === 24) apiEndPoint = this.POINTPRO_ENDPOINT;
    else if (endpoint === 25) apiEndPoint = this.DFS_GROUP_API_ENDPOINT;
    else if (endpoint === 26) apiEndPoint = this.DFS_LOYALTY_ENDPOINT;
    else if (endpoint === 27) apiEndPoint = this.CAMPAIGN_ENDPOINT;
    else if (endpoint === 28) apiEndPoint = this.PRODIGI_CREDIT_ENDPOINT;
    else if (endpoint === 30) apiEndPoint = this.DFS_USER_MANAGEMENT_ENDPOINT;
    else if (endpoint === 31) apiEndPoint = this.DFS_WALLET_MANAGEMENT_ENDPOINT;
    else if (endpoint === 35) apiEndPoint = this.DFS_ENDPOINT;
    else if (endpoint === 32) apiEndPoint = this.MFS_WALLET_MANAGEMENT_ENDPOINT;
    else if (endpoint === 33) apiEndPoint = this.DFS_LOGIN_MANAGEMENT_ENDPOINT;

    //apiEndPoint="http://localhost:8080/mfs-biller-gateway/biller/";
    let header = headers ? this.jwt(headers) : this.jwt();

    if (type == "blob") {
      return this.http
        .post(apiEndPoint + url, param, header)
        .map(
          (res) =>
            new Blob([res.blob()], { type: "text/csv;charset=ISO-8859-1" })
        );
    } else {
      return this.http
        .post(apiEndPoint + url, param, header)
        .map((res) => res.json());
    }
  }

  put(
    url,
    param?: any,
    endpoint = 2,
    headers?: RequestOptions,
    type = null
  ): any {
    let apiEndPoint = this.API_ENDPOINT;
    if (endpoint === 0) apiEndPoint = this.BASE_ENDPOINT;
    else if (endpoint === 1) apiEndPoint = this.HSM_API_ENDPOINT;
    else if (endpoint === 3) apiEndPoint = this.MFS_API_ENDPOINT;
    else if (endpoint === 4) apiEndPoint = this.MFS_USER_GROUP_API_ENDPOINT;
    else if (endpoint === 5) apiEndPoint = this.WALLET_MANAGEMENT_ENDPOINT;
    else if (endpoint === 6) apiEndPoint = this.ENDPOINT;
    else if (endpoint === 7) apiEndPoint = this.USER_MFS;
    else if (endpoint === 8) apiEndPoint = this.LIMIT_MANAGEMENT_ENDPOINT;
    else if (endpoint === 9) apiEndPoint = this.LOGIN_MFS;
    else if (endpoint === 13) apiEndPoint = this.MFS_SERVICE_ENDPOINT;
    else if (endpoint === 10)
      apiEndPoint = this.MFS_SERVICE_GROUP_MANAGEMENT_ENDPOINT;
    else if (endpoint === 15) apiEndPoint = this.OPERATIONS_ENDPOINT;
    else if (endpoint === 16) apiEndPoint = this.MFS_REPORTING_ENDPOINT;
    else if (endpoint === 17) apiEndPoint = this.MFS_BILLER_MANAGEMENT_ENDPOINT;
    else if (endpoint === 19) apiEndPoint = this.COMMON_UTILS;
    else if (endpoint === 18) apiEndPoint = this.DASHBOARD_ENDPOINT;
    else if (endpoint === 20)
      apiEndPoint = this.MFS_TRANSACTION_MANAGEMENT_API_ENDPOINT;
    else if (endpoint === 22) apiEndPoint = this.MFS_HIERARCHY_DOWNLOAD;
    else if (endpoint === 23) apiEndPoint = this.SMS_ENDPOINT;
    else if (endpoint === 24) apiEndPoint = this.POINTPRO_ENDPOINT;
    else if (endpoint === 25) apiEndPoint = this.DFS_GROUP_API_ENDPOINT;
    else if (endpoint === 26) apiEndPoint = this.DFS_LOYALTY_ENDPOINT;
    else if (endpoint === 27) apiEndPoint = this.CAMPAIGN_ENDPOINT;
    else if (endpoint === 28) apiEndPoint = this.PRODIGI_CREDIT_ENDPOINT;
    else if (endpoint === 30) apiEndPoint = this.DFS_USER_MANAGEMENT_ENDPOINT;
    else if (endpoint === 31) apiEndPoint = this.DFS_WALLET_MANAGEMENT_ENDPOINT;
    else if (endpoint === 35) apiEndPoint = this.DFS_ENDPOINT;
    else if (endpoint === 32) apiEndPoint = this.MFS_WALLET_MANAGEMENT_ENDPOINT;
    else if (endpoint === 33) apiEndPoint = this.DFS_LOGIN_MANAGEMENT_ENDPOINT;

    let header = headers ? this.jwt(headers) : this.jwt();

    if (type == "blob") {
      return this.http
        .put(apiEndPoint + url, param, header)
        .map(
          (res) =>
            new Blob([res.blob()], { type: "text/csv;charset=ISO-8859-1" })
        );
    } else {
      return this.http
        .put(apiEndPoint + url, param, header)
        .map((res) => res.json());
    }
  }

  delete(url, endpoint = 2, headers?: RequestOptions): any {
    let apiEndPoint = this.API_ENDPOINT;
    if (endpoint === 0) apiEndPoint = this.BASE_ENDPOINT;
    else if (endpoint === 1) apiEndPoint = this.HSM_API_ENDPOINT;
    else if (endpoint === 3) apiEndPoint = this.MFS_API_ENDPOINT;
    else if (endpoint === 4) apiEndPoint = this.MFS_USER_GROUP_API_ENDPOINT;
    else if (endpoint === 5) apiEndPoint = this.WALLET_MANAGEMENT_ENDPOINT;
    else if (endpoint === 6) apiEndPoint = this.ENDPOINT;
    else if (endpoint === 7) apiEndPoint = this.USER_MFS;
    else if (endpoint === 8) apiEndPoint = this.LIMIT_MANAGEMENT_ENDPOINT;
    else if (endpoint === 9) apiEndPoint = this.LOGIN_MFS;
    else if (endpoint === 13) apiEndPoint = this.MFS_SERVICE_ENDPOINT;
    else if (endpoint === 10)
      apiEndPoint = this.MFS_SERVICE_GROUP_MANAGEMENT_ENDPOINT;
    else if (endpoint === 15) apiEndPoint = this.OPERATIONS_ENDPOINT;
    else if (endpoint === 16) apiEndPoint = this.MFS_REPORTING_ENDPOINT;
    else if (endpoint === 17) apiEndPoint = this.MFS_BILLER_MANAGEMENT_ENDPOINT;
    else if (endpoint === 19) apiEndPoint = this.COMMON_UTILS;
    else if (endpoint === 18) apiEndPoint = this.DASHBOARD_ENDPOINT;
    else if (endpoint === 20)
      apiEndPoint = this.MFS_TRANSACTION_MANAGEMENT_API_ENDPOINT;
    else if (endpoint === 22) apiEndPoint = this.MFS_HIERARCHY_DOWNLOAD;
    else if (endpoint === 23) apiEndPoint = this.SMS_ENDPOINT;
    else if (endpoint === 24) apiEndPoint = this.POINTPRO_ENDPOINT;
    else if (endpoint === 25) apiEndPoint = this.DFS_GROUP_API_ENDPOINT;
    else if (endpoint === 26) apiEndPoint = this.DFS_LOYALTY_ENDPOINT;
    else if (endpoint === 27) apiEndPoint = this.CAMPAIGN_ENDPOINT;
    else if (endpoint === 28) apiEndPoint = this.PRODIGI_CREDIT_ENDPOINT;
    else if (endpoint === 30) apiEndPoint = this.DFS_USER_MANAGEMENT_ENDPOINT;
    else if (endpoint === 31) apiEndPoint = this.DFS_WALLET_MANAGEMENT_ENDPOINT;
    else if (endpoint === 35) apiEndPoint = this.DFS_ENDPOINT;
    else if (endpoint === 32) apiEndPoint = this.MFS_WALLET_MANAGEMENT_ENDPOINT;
    else if (endpoint === 33) apiEndPoint = this.DFS_LOGIN_MANAGEMENT_ENDPOINT;
    else if (endpoint === 34) apiEndPoint = this.DFS_AUTHORIZATION_SERVER_ENDPOINT;

    let header = headers ? this.jwt(headers) : this.jwt();
    return this.http.delete(apiEndPoint + url, header).map((res) => res.json());
  }

  postFile(url, formData?: any, endpoint = 2, headers?: RequestOptions): any {
    let apiEndPoint = this.API_ENDPOINT;
    if (endpoint === 0) apiEndPoint = this.BASE_ENDPOINT;
    else if (endpoint === 1) apiEndPoint = this.HSM_API_ENDPOINT;
    else if (endpoint === 3) apiEndPoint = this.MFS_API_ENDPOINT;
    else if (endpoint === 4) apiEndPoint = this.MFS_USER_GROUP_API_ENDPOINT;
    else if (endpoint === 5) apiEndPoint = this.WALLET_MANAGEMENT_ENDPOINT;
    else if (endpoint === 6) apiEndPoint = this.MFS_WALLET_MANAGEMENT_ENDPOINT;
    else if (endpoint === 10) apiEndPoint = this.COMMON_UTILS;
    else if (endpoint === 10)
      apiEndPoint = this.MFS_SERVICE_GROUP_MANAGEMENT_ENDPOINT;
    else if (endpoint === 11) apiEndPoint = this.COMMON_UTILS_HIERARCHY;
    else if (endpoint === 18) apiEndPoint = this.DASHBOARD_ENDPOINT;
    else if (endpoint === 7) apiEndPoint = this.USER_MFS;

    let header: RequestOptions = headers ? this.jwt(headers) : this.jwt();
    //      header.headers.delete("Content-Type");
    for (var a in fileUploadHeaders) {
      header.headers.append(a, fileUploadHeaders[a]);
    }
    header.headers.forEach((o, i) => {});
    return this.ser.upload(apiEndPoint + url, formData, header);
  }

  private jwt(header?, extraRequestOption?): RequestOptions {
    let headObj = {
      locale: "en",
      language: "ENG",
    };
    let headers;
    if (header) {
      if (header instanceof RequestOptions) {
        return header;
      }
      headObj = Object.assign(headObj, header);
    }
    // Get token from commonService or localStorage directly (like axios interceptor pattern)
    let token = this.commonService.token;
    if (!token) {
      token = localStorage.getItem("tkn");
    }
    if (token != null && token !== "") {
      headObj[this.commonService.authToken] = token;
      // headObj[this.commonService.headerUserId] = this.commonService.getUserId();

      headers = new Headers(headObj);
      var d = { headers: headers };
      if (extraRequestOption) {
        d = Object.assign(d, extraRequestOption);
      }
      return new RequestOptions(d);
    } else {
      headers = new Headers(headObj);
      var d = { headers: headers };
      if (extraRequestOption) {
        d = Object.assign(d, extraRequestOption);
      }
      return new RequestOptions(d);
    }
  }
}
const fileUploadHeaders = {
  "Cache-Control": "no-cache",
  Pragma: "no-cache",
  "Process-Data": false,
};



// WEBPACK FOOTER //
// /Users/ldt/Desktop/ARES-admin-frontend/src/app/common/http-client.service.ts